import { createContext } from "react";

import { CompanyFragment } from "../../graphql/graphql";

export type Company = Pick<CompanyFragment, "id" | "name">;

interface CompanyProviderState {
  currentCompany: Company | undefined;
  companies: Company[];
  setCurrentCompany: (company: Company | undefined) => void;
}

const initialState: CompanyProviderState = {
  currentCompany: undefined,
  companies: [],
  setCurrentCompany: () => {
    // Intentionally left empty
  },
};

export const CompanyProviderContext =
  createContext<CompanyProviderState>(initialState);
